// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/ng-sortable/dist/ng-sortable.min.css
// module id = 63
// module chunks = 0